module.exports = __webpack_public_path__ + "img/teac_ecology.6eccbe9f.png";